import React from 'react'
import {CONTRACT_TYPE_ORDER, getContractTypeMeta} from '../../common/domain/contractType'
import {Box} from '../../webui/Box'
import {Container} from '../../webui/Container'
import {Paper} from '../../webui/Paper'
import {Typography} from '../../webui/Typography'
import {Table} from '../../webui/table/Table'
import {TableBody} from '../../webui/table/TableBody'
import {TableCell} from '../../webui/table/TableCell'
import {TableContainer} from '../../webui/table/TableContainer'
import {TableHead} from '../../webui/table/TableHead'
import {TableRow} from '../../webui/table/TableRow'

interface Props {}

export const ContractTypesInfoPage: React.FC<Props> = () => {
  return (
    <Container>
      <Box my={2}>
        <Paper>
          <Box p={3}>
            <Typography variant="h3">Contract types / Avtalstyper</Typography>

            <Box mt={1}>
              <Typography variant="body2" color="textSecondary">
                This page documents the contract types used in Piffl Admin. Contract type is set per <strong>Box</strong>, and organisations derive
                their list of contract types from their boxes.
              </Typography>
            </Box>

            <Box mt={3}>
              <TableContainer>
                <Table aria-label="contract types table">
                  <TableHead>
                    <TableRow>
                      {/* Label */}
                      <TableCell align="left">Label</TableCell>

                      {/* Description */}
                      <TableCell align="left">Description</TableCell>

                      {/* Spacer column keeps the description area from stretching too wide */}
                      <TableCell />
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {CONTRACT_TYPE_ORDER.map((t) => {
                      const meta = getContractTypeMeta(t)
                      const label = meta?.label ?? String(t)
                      const descriptionItems = meta?.descriptionItems ?? []

                      return (
                        <TableRow key={t}>
                          <TableCell align="left">
                            <Typography variant="body2">{label}</Typography>
                          </TableCell>

                          <TableCell align="left">
                            {descriptionItems.length === 0 ? (
                              <Typography variant="body2" color="textSecondary">
                                {''}
                              </Typography>
                            ) : (
                              <Box component="ul" m={0} pl={2}>
                                {descriptionItems.map((item) => (
                                  <li key={item}>
                                    <Typography variant="body2" color="textSecondary">
                                      {item}
                                    </Typography>
                                  </li>
                                ))}
                              </Box>
                            )}
                          </TableCell>

                          {/* Spacer */}
                          <TableCell />
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box mt={3}>
              <Typography variant="h6">Notes</Typography>
              <Box mt={1}>
                <Box component="ul" m={0} pl={2}>
                  <li>
                    <Typography variant="body2" color="textSecondary">
                      De olika avtalstyperna är aktiva parallellt.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2" color="textSecondary">
                      Standard-drift från och med augusti 2024 är <strong>Full Service 2</strong>.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2" color="textSecondary">
                      Avsteg från standard kan ske case-by-case vid behov.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2" color="textSecondary">
                      Care+ är ersatt med Full service 2.
                    </Typography>
                  </li>
                </Box>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  )
}
